(function () {
  'use strict';

  function normalizeRatingMarkup(root) {
    var container = root.querySelector('.z2bs__rating-filters');
    if (!container) return;

    container.innerHTML = [
      '<label>',
        '<input type="radio" name="z2bs-rating-runtime" value="4.75" data-z2-rating-filter>',
        '<i aria-hidden="true"></i>',
        '<span class="z2bs__rating-stars" aria-label="5 stars and up">★★★★★</span>',
      '</label>',
      '<label>',
        '<input type="radio" name="z2bs-rating-runtime" value="4" data-z2-rating-filter>',
        '<i aria-hidden="true"></i>',
        '<span class="z2bs__rating-stars" aria-label="4 stars and up">',
          '★★★★<span class="z2bs__star-dim">★</span>',
          '<span class="z2bs__rating-up">&amp; Up</span>',
        '</span>',
      '</label>',
      '<label>',
        '<input type="radio" name="z2bs-rating-runtime" value="3" data-z2-rating-filter>',
        '<i aria-hidden="true"></i>',
        '<span class="z2bs__rating-stars" aria-label="3 stars and up">',
          '★★★<span class="z2bs__star-dim">★★</span>',
          '<span class="z2bs__rating-up">&amp; Up</span>',
        '</span>',
      '</label>'
    ].join('');
  }

  function init(root) {
    if (!root || root.dataset.z2FilterReady === 'true') return;

    normalizeRatingMarkup(root);

    root.dataset.z2FilterReady = 'true';

    var filterPanel = root.querySelector('[data-z2-filter-panel]');
    var minPrice = root.querySelector('[data-z2-min-price]');
    var maxPrice = root.querySelector('[data-z2-max-price]');
    var rangeFill = root.querySelector('[data-z2-range-fill]');
    var minLabel = root.querySelector('[data-z2-min-label]');
    var maxLabel = root.querySelector('[data-z2-max-label]');
    var noResults = root.querySelector('[data-z2-no-results]');
    var activeCount = root.querySelector('[data-z2-active-filter-count]');
    var sortSelect = root.querySelector('[data-z2-sort]');
    var currentPricePreset = '';
    var currentSort = sortSelect ? sortSelect.value : 'featured';

    function cards() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-z2-card]'));
    }

    function sections() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-z2-section]'));
    }

    function selectedRating() {
      var input = root.querySelector('[data-z2-rating-filter]:checked');
      return input ? Number(input.value) : 0;
    }

    function selectedCategories() {
      return Array.prototype.slice
        .call(root.querySelectorAll('[data-z2-category-filter]:checked'))
        .map(function (input) {
          return input.value;
        });
    }

    function resetPrice() {
      currentPricePreset = '';
      if (minPrice) minPrice.value = minPrice.min || '0';
      if (maxPrice) {
        maxPrice.value =
          maxPrice.max ||
          root.dataset.priceMax ||
          '1000';
      }
    }

    function setOnlyCategory(value) {
      root.querySelectorAll('[data-z2-category-filter]').forEach(function (input) {
        input.checked = input.value === value;
      });
    }

    function syncRange() {
      if (!minPrice || !maxPrice) return;

      var floor = Number(minPrice.min || 0);
      var ceiling = Number(maxPrice.max || root.dataset.priceMax || 1000);
      var low = Number(minPrice.value || floor);
      var high = Number(maxPrice.value || ceiling);

      if (low >= high) {
        if (document.activeElement === minPrice) {
          low = Math.max(floor, high - 1);
        } else {
          high = Math.min(ceiling, low + 1);
        }
      }

      minPrice.value = String(low);
      maxPrice.value = String(high);

      var total = Math.max(1, ceiling - floor);

      if (rangeFill) {
        rangeFill.style.left = (((low - floor) / total) * 100) + '%';
        rangeFill.style.right =
          (100 - ((high - floor) / total) * 100) + '%';
      }

      if (minLabel) minLabel.textContent = '$' + low;
      if (maxLabel) {
        maxLabel.textContent =
          high >= ceiling ? '$' + ceiling + '+' : '$' + high;
      }
    }

    function syncCategoryChips() {
      var categories = selectedCategories();

      root.querySelectorAll('[data-z2-category-chip]').forEach(function (button) {
        var value = button.dataset.z2CategoryChip || '';
        var active = false;

        if (value === '') {
          active =
            categories.length === 0 &&
            currentPricePreset !== 'range-1';
        } else if (value === 'under25') {
          active =
            currentPricePreset === 'range-1' &&
            categories.length === 0;
        } else {
          active =
            currentPricePreset !== 'range-1' &&
            categories.length === 1 &&
            categories[0] === value;
        }

        button.classList.toggle('is-active', active);
      });
    }

    function updateActiveCount() {
      var count = 0;
      var floor = Number(minPrice ? minPrice.min || 0 : 0);
      var ceiling = Number(
        maxPrice
          ? maxPrice.max || root.dataset.priceMax || 1000
          : 1000
      );

      if (
        currentPricePreset ||
        Number(minPrice && minPrice.value || floor) > floor ||
        Number(maxPrice && maxPrice.value || ceiling) < ceiling
      ) {
        count += 1;
      }

      if (selectedRating()) count += 1;
      count += selectedCategories().length;

      if (activeCount) {
        activeCount.textContent = count ? '(' + count + ')' : '';
      }
    }

    function updatePresetButtons() {
      root.querySelectorAll('[data-z2-price-preset]').forEach(function (button) {
        button.classList.toggle(
          'is-active',
          button.dataset.z2PricePreset === currentPricePreset
        );
      });
    }

    function sortSection(section) {
      var slider = section.querySelector('.z2-bs-slider');
      if (!slider) return;

      var sectionCards = Array.prototype.slice.call(
        slider.querySelectorAll('[data-z2-card]')
      );

      sectionCards.sort(function (a, b) {
        var sourceDifference =
          Number(a.dataset.z2Source || 0) -
          Number(b.dataset.z2Source || 0);

        if (
          currentSort === 'featured' ||
          currentSort === 'best-selling'
        ) {
          return sourceDifference;
        }

        if (currentSort === 'newest') {
          return (
            Number(b.dataset.z2Created || 0) -
              Number(a.dataset.z2Created || 0) ||
            sourceDifference
          );
        }

        if (
          currentSort === 'highest-rated' ||
          currentSort === 'rating'
        ) {
          return (
            Number(b.dataset.z2Rating || 0) -
              Number(a.dataset.z2Rating || 0) ||
            sourceDifference
          );
        }

        if (currentSort === 'price-asc') {
          return (
            Number(a.dataset.z2Price || 0) -
              Number(b.dataset.z2Price || 0) ||
            sourceDifference
          );
        }

        if (currentSort === 'price-desc') {
          return (
            Number(b.dataset.z2Price || 0) -
              Number(a.dataset.z2Price || 0) ||
            sourceDifference
          );
        }

        if (currentSort === 'discount') {
          return (
            Number(b.dataset.z2Discount || 0) -
              Number(a.dataset.z2Discount || 0) ||
            sourceDifference
          );
        }

        return sourceDifference;
      });

      sectionCards.forEach(function (card) {
        slider.appendChild(card);
      });
    }

    function updateVisibleRanks() {
      sections().forEach(function (section) {
        var visibleIndex = 0;

        Array.prototype.slice
          .call(section.querySelectorAll('[data-z2-card]'))
          .forEach(function (card) {
            var rank = card.querySelector('.z2-bs-rank');

            if (!rank) return;

            if (
              card.classList.contains('is-hidden') ||
              section.classList.contains('is-hidden')
            ) {
              return;
            }

            visibleIndex += 1;
            rank.textContent = '#' + visibleIndex;
            rank.classList.toggle(
              'z2-bs-rank--top',
              visibleIndex <= 3
            );
          });
      });
    }

    function updateArrows() {
      root.querySelectorAll('.z2-bs-slider-wrap').forEach(function (wrap) {
        var slider = wrap.querySelector('.z2-bs-slider');
        var prev = wrap.querySelector('.z2-bs-prev');
        var next = wrap.querySelector('.z2-bs-next');

        if (!slider || !prev || !next) return;

        var visibleCards = Array.prototype.slice
          .call(slider.querySelectorAll('.z2-bs-card'))
          .filter(function (card) {
            return !card.classList.contains('is-hidden');
          });

        var overflow =
          visibleCards.length > 0 &&
          slider.scrollWidth > slider.clientWidth + 4;

        var atStart = slider.scrollLeft <= 4;
        var atEnd =
          slider.scrollLeft + slider.clientWidth >=
          slider.scrollWidth - 4;

        prev.classList.toggle('is-hidden', !overflow || atStart);
        next.classList.toggle('is-hidden', !overflow || atEnd);
      });
    }

    function applyFilters() {
      syncRange();

      var minimumPrice = Number(minPrice && minPrice.value || 0);
      var maximumPrice = Number(maxPrice && maxPrice.value || 1000);
      var maximumLimit = Number(
        maxPrice && maxPrice.max ||
        root.dataset.priceMax ||
        1000
      );
      var minimumRating = selectedRating();
      var categories = selectedCategories();
      var totalVisible = 0;

      sections().forEach(sortSection);

      cards().forEach(function (card) {
        var price = Number(card.dataset.z2Price || 0);
        var rating = Number(card.dataset.z2Rating || 0);
        var department = card.dataset.z2Dept || '';

        var priceMatch =
          price >= minimumPrice &&
          (maximumPrice >= maximumLimit || price <= maximumPrice);

        var ratingMatch =
          !minimumRating ||
          rating >= minimumRating;

        var categoryMatch =
          !categories.length ||
          categories.indexOf(department) !== -1;

        var visible =
          priceMatch &&
          ratingMatch &&
          categoryMatch;

        card.classList.toggle('is-hidden', !visible);

        if (visible) totalVisible += 1;
      });

      sections().forEach(function (section) {
        var department = section.dataset.z2Dept || '';
        var categoryAllowed =
          !categories.length ||
          categories.indexOf(department) !== -1;

        var visibleCards =
          section.querySelectorAll('[data-z2-card]:not(.is-hidden)').length;

        section.classList.toggle(
          'is-hidden',
          !categoryAllowed || visibleCards === 0
        );
      });

      if (noResults) {
        noResults.classList.toggle('is-visible', totalVisible === 0);
      }

      updateActiveCount();
      updatePresetButtons();
      syncCategoryChips();
      updateVisibleRanks();
      requestAnimationFrame(updateArrows);
    }

    function clearFilters() {
      resetPrice();

      root.querySelectorAll(
        '[data-z2-rating-filter],[data-z2-category-filter]'
      ).forEach(function (input) {
        input.checked = false;
      });

      applyFilters();
    }

    function openFilters() {
      if (window.matchMedia('(max-width: 989px)').matches) {
        root.classList.add('is-filter-open');
        document.body.classList.add('z2bs-filter-locked');

        if (filterPanel) {
          filterPanel.setAttribute('aria-hidden', 'false');
          setTimeout(function () {
            filterPanel.focus();
          }, 50);
        }
      } else if (filterPanel) {
        filterPanel.scrollIntoView({
          behavior:'smooth',
          block:'start'
        });
        filterPanel.focus({ preventScroll:true });
      }
    }

    function closeFilters() {
      root.classList.remove('is-filter-open');
      document.body.classList.remove('z2bs-filter-locked');

      if (filterPanel) {
        filterPanel.setAttribute(
          'aria-hidden',
          window.matchMedia('(max-width: 989px)').matches
            ? 'true'
            : 'false'
        );
      }
    }

    root.addEventListener('click', function (event) {
      var categoryChip = event.target.closest('[data-z2-category-chip]');

      if (categoryChip) {
        event.preventDefault();

        var chipValue = categoryChip.dataset.z2CategoryChip || '';

        if (chipValue === '') {
          resetPrice();
          setOnlyCategory('');
        } else if (chipValue === 'under25') {
          setOnlyCategory('');
          currentPricePreset = 'range-1';

          if (minPrice) minPrice.value = '0';
          if (maxPrice) maxPrice.value = '25';
        } else {
          resetPrice();
          setOnlyCategory(chipValue);
        }

        applyFilters();
        return;
      }

      var openButton = event.target.closest('[data-z2-open-filters]');
      if (openButton) {
        event.preventDefault();
        openFilters();
        return;
      }

      var closeButton = event.target.closest('[data-z2-close-filters]');
      if (closeButton) {
        event.preventDefault();

        if (closeButton.matches('[data-z2-apply-filters]')) {
          applyFilters();
        }

        closeFilters();
        return;
      }

      var clearButton = event.target.closest('[data-z2-clear-filters]');
      if (clearButton) {
        event.preventDefault();
        clearFilters();
        return;
      }

      var preset = event.target.closest('[data-z2-price-preset]');
      if (preset) {
        event.preventDefault();

        currentPricePreset = preset.dataset.z2PricePreset || '';

        if (minPrice) minPrice.value = preset.dataset.min || '0';
        if (maxPrice) {
          maxPrice.value =
            preset.dataset.max ||
            root.dataset.priceMax ||
            '1000';
        }

        applyFilters();
        return;
      }

      var arrow = event.target.closest('.z2-bs-arrow');
      if (arrow) {
        var wrap = arrow.closest('.z2-bs-slider-wrap');
        var slider = wrap ? wrap.querySelector('.z2-bs-slider') : null;

        if (!slider) return;

        var card = slider.querySelector('.z2-bs-card:not(.is-hidden)');
        var gap =
          Number.parseFloat(window.getComputedStyle(slider).gap) || 0;
        var amount = card
          ? (card.offsetWidth + gap) * 4
          : Math.max(400, slider.clientWidth * .9);

        slider.scrollBy({
          left:arrow.classList.contains('z2-bs-prev')
            ? -amount
            : amount,
          behavior:'smooth'
        });

        return;
      }

      var cardElement = event.target.closest('.z2-bs-card');

      if (
        cardElement &&
        !event.target.closest('a,button,input,label,summary,select')
      ) {
        var url = cardElement.dataset.url;
        if (url) window.location.href = url;
      }
    });

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-z2-sort]')) {
        currentSort = event.target.value || 'newest';
        applyFilters();
        return;
      }

      if (
        event.target.matches(
          '[data-z2-rating-filter],[data-z2-category-filter]'
        )
      ) {
        applyFilters();
      }
    });

    root.addEventListener('input', function (event) {
      if (
        event.target.matches(
          '[data-z2-min-price],[data-z2-max-price]'
        )
      ) {
        currentPricePreset = '';
        applyFilters();
      }
    });

    root.querySelectorAll('.z2-bs-slider').forEach(function (slider) {
      slider.addEventListener('scroll', function () {
        requestAnimationFrame(updateArrows);
      }, { passive:true });
    });

    window.addEventListener('resize', function () {
      if (!window.matchMedia('(max-width: 989px)').matches) {
        closeFilters();
      }
      updateArrows();
    });

    document.addEventListener('keydown', function (event) {
      if (
        event.key === 'Escape' &&
        root.classList.contains('is-filter-open')
      ) {
        closeFilters();
      }
    });

    syncRange();
    applyFilters();
    updateVisibleRanks();
    updateArrows();
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-z2-best-sellers]')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();


(function(){ const Z2_WISHLIST_KEY = 'z2_wishlist_items'; function z2GetWishlist(){ try{ const items = JSON.parse(localStorage.getItem(Z2_WISHLIST_KEY) || '[]'); return Array.isArray(items) ? items : []; }catch(error){ return []; } } function z2SaveWishlist(items){ localStorage.setItem(Z2_WISHLIST_KEY, JSON.stringify(items)); document.dispatchEvent(new CustomEvent('z2:wishlist-updated', { detail:{ count:items.length, items:items } })); } function z2IsInWishlist(handle){ return z2GetWishlist().some(function(item){ return String(item.handle || '') === String(handle || ''); }); } function z2UpdateOneButton(button){ const handle = String(button.getAttribute('data-product-handle') || ''); const active = z2IsInWishlist(handle); button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', active ? 'true' : 'false'); button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist'); } function z2UpdateAllButtons(){ document.querySelectorAll('[data-z2-wishlist]').forEach(function(button){ z2UpdateOneButton(button); }); } function z2ToggleWishlist(button){ const item = { handle:String(button.getAttribute('data-product-handle') || ''), title:String(button.getAttribute('data-product-title') || 'Product'), url:String(button.getAttribute('data-product-url') || '#'), image:String(button.getAttribute('data-product-image') || ''), price:String(button.getAttribute('data-product-price') || '') }; if(!item.handle) return; let wishlist = z2GetWishlist(); const exists = wishlist.some(function(product){ return String(product.handle || '') === item.handle; }); if(exists){ wishlist = wishlist.filter(function(product){ return String(product.handle || '') !== item.handle; }); }else{ wishlist.unshift(item); } z2SaveWishlist(wishlist); z2UpdateAllButtons(); } document.addEventListener('click', function(event){ const button = event.target.closest('[data-z2-wishlist]'); if(!button) return; event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation(); z2ToggleWishlist(button); }, true); document.addEventListener('DOMContentLoaded', z2UpdateAllButtons); document.addEventListener('shopify:section:load', z2UpdateAllButtons); document.addEventListener('z2:wishlist-updated', z2UpdateAllButtons); setTimeout(z2UpdateAllButtons, 300); setTimeout(z2UpdateAllButtons, 1000); })();

(function(){ function z2InitBsCollectionCardTouchHover(rootNode){ var scope=rootNode&&rootNode.querySelectorAll ? rootNode : document; var cards=Array.from(scope.querySelectorAll(".z2-bs-wrap .z2-bs-card")); if(!cards.length&&scope!==document){ cards=Array.from(document.querySelectorAll(".z2-bs-wrap .z2-bs-card")); } cards.forEach(function(card){ if(card.dataset.z2BsHoverReady==="true")return; card.dataset.z2BsHoverReady="true"; var startX=0; var startY=0; var moved=false; var touchSession=false; var clearTimer=null; function clearOtherCards(){ document.querySelectorAll(".z2-bs-card.z2-bs-card-touch-light").forEach(function(otherCard){ if(otherCard!==card){ otherCard.classList.remove("z2-bs-card-touch-light"); } }); } function clearThisCardLater(){ if(clearTimer){ window.clearTimeout(clearTimer); } clearTimer=window.setTimeout(function(){ card.classList.remove("z2-bs-card-touch-light"); touchSession=false; },900); } card.addEventListener("pointerdown",function(event){ if(event.pointerType!=="touch"&&event.pointerType!=="pen")return; if(!window.matchMedia("(max-width: 749px), (hover: none), (pointer: coarse)").matches)return; startX=event.clientX; startY=event.clientY; moved=false; touchSession=true; if(clearTimer){ window.clearTimeout(clearTimer); clearTimer=null; } clearOtherCards(); card.classList.add("z2-bs-card-touch-light"); }); card.addEventListener("pointermove",function(event){ if(!touchSession)return; if( Math.abs(event.clientX-startX)>10|| Math.abs(event.clientY-startY)>10 ){ moved=true; touchSession=false; card.classList.remove("z2-bs-card-touch-light"); } }); card.addEventListener("pointercancel",function(){ moved=true; touchSession=false; card.classList.remove("z2-bs-card-touch-light"); }); card.addEventListener("pointerup",function(){ if(touchSession){ clearThisCardLater(); } }); card.addEventListener("click",function(event){ if(!touchSession)return; if(!window.matchMedia("(max-width: 749px), (hover: none), (pointer: coarse)").matches)return; if( event.metaKey|| event.ctrlKey|| event.shiftKey|| event.altKey ){ return; } if(moved){ event.preventDefault(); return; } if(event.target.closest("[data-z2-wishlist],[data-qv],[data-add],[data-buy]")){ clearThisCardLater(); return; } var productLink=event.target.closest("a[href]"); var destination=productLink ? productLink.href : card.getAttribute("data-url"); if(!destination)return; event.preventDefault(); event.stopPropagation(); if(clearTimer){ window.clearTimeout(clearTimer); clearTimer=null; } clearOtherCards(); void card.offsetWidth; card.classList.add("z2-bs-card-touch-light"); window.setTimeout(function(){ window.location.assign(destination); },700); }); }); } if(document.readyState==="loading"){ document.addEventListener("DOMContentLoaded",function(){ z2InitBsCollectionCardTouchHover(document); }); }else{ z2InitBsCollectionCardTouchHover(document); } document.addEventListener("shopify:section:load",function(event){ z2InitBsCollectionCardTouchHover(event.target); }); })();

(function(){
  'use strict';

  var RECENT_KEY = 'z2tnfix_recent_products';
  var recommendationRequestId = 0;

  function rootPath(){
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function currencyCode(){
    return (
      window.Shopify &&
      Shopify.currency &&
      Shopify.currency.active
    ) || 'USD';
  }

  function formatMoney(cents){
    var numeric = Number(cents || 0);

    try{
      return new Intl.NumberFormat('en-US',{
        style:'currency',
        currency:currencyCode()
      }).format(numeric / 100);
    }catch(error){
      return '$' + (numeric / 100).toFixed(2);
    }
  }

  function readRecent(){
    try{
      var items = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(items) ? items : [];
    }catch(error){
      return [];
    }
  }

  function writeRecent(items){
    try{
      localStorage.setItem(
        RECENT_KEY,
        JSON.stringify(items.slice(0,8))
      );
    }catch(error){}
  }

  function normalizeProduct(product){
    if(!product) return null;

    var image = product.image || product.featured_image || '';

    if(image && typeof image === 'object'){
      image = image.url || image.src || '';
    }

    var handle = String(product.handle || '').trim();
    var url = String(
      product.url ||
      (handle ? rootPath() + 'products/' + handle : '')
    );

    if(!handle && !url) return null;

    return {
      id:String(product.id || ''),
      handle:handle,
      title:String(product.title || 'Product'),
      url:url,
      image:String(image || ''),
      priceCents:Number(
        product.priceCents != null
          ? product.priceCents
          : product.price || 0
      )
    };
  }

  function rememberProduct(product){
    var item = normalizeProduct(product);
    if(!item) return;

    var items = readRecent().filter(function(existing){
      return existing && existing.handle !== item.handle;
    });

    items.unshift(item);
    writeRecent(items);
    renderDiscoveryShelves();
  }

  function rememberCard(card){
    if(!card) return;

    rememberProduct({
      id:card.dataset.productId || '',
      handle:card.dataset.productHandle || '',
      title:card.dataset.productTitle || '',
      url:card.dataset.url || '',
      image:card.dataset.productImage || '',
      priceCents:Number(card.dataset.productPriceCents || 0)
    });
  }

  function miniCard(product,type){
    var item = normalizeProduct(product);
    if(!item) return null;

    var link = document.createElement('a');
    link.className = 'z2-bs-mini-card';
    link.href = item.url;
    link.dataset.z2BsMiniProduct = '';
    link.dataset.miniType = type || '';
    link.dataset.productId = item.id;
    link.dataset.productHandle = item.handle;
    link.dataset.productTitle = item.title;
    link.dataset.productUrl = item.url;
    link.dataset.productImage = item.image;
    link.dataset.productPriceCents = String(item.priceCents);

    var image = document.createElement('img');
    image.loading = 'lazy';
    image.decoding = 'async';
    image.width = 68;
    image.height = 68;
    image.src = item.image;
    image.alt = item.title;

    var copy = document.createElement('div');
    copy.className = 'z2-bs-mini-copy';

    var title = document.createElement('strong');
    title.textContent = item.title;

    var price = document.createElement('span');
    price.textContent = formatMoney(item.priceCents);

    copy.appendChild(title);
    copy.appendChild(price);
    link.appendChild(image);
    link.appendChild(copy);

    return link;
  }

  function skeleton(){
    var item = document.createElement('div');
    item.className = 'z2-bs-mini-card z2-bs-mini-skeleton';
    item.setAttribute('aria-hidden','true');
    item.innerHTML =
      '<i></i>' +
      '<div class="z2-bs-mini-copy">' +
      '<b></b><b></b>' +
      '</div>';

    return item;
  }

  function shelfElements(){
    var root = document.querySelector('[data-z2-filter-section]');

    if(!root) return null;

    return {
      root:root,
      recent:root.querySelector('[data-z2-bs-recent]'),
      recentGrid:root.querySelector('[data-z2-bs-recent-grid]'),
      recommendations:root.querySelector('[data-z2-bs-recommendations]'),
      recommendationsGrid:root.querySelector(
        '[data-z2-bs-recommendations-grid]'
      )
    };
  }

  function showShelf(section,visible){
    if(!section) return;
    section.hidden = !visible;
    section.classList.toggle('is-visible',visible);
  }

  function renderRecent(elements,items){
    elements.recentGrid.innerHTML = '';

    items.slice(0,4).forEach(function(product){
      var card = miniCard(product,'recent');
      if(card) elements.recentGrid.appendChild(card);
    });

    showShelf(
      elements.recent,
      elements.recentGrid.children.length > 0
    );
  }

  async function loadRecommendations(elements,productId,recentItems){
    if(!productId){
      elements.recommendationsGrid.innerHTML = '';
      showShelf(elements.recommendations,false);
      return;
    }

    var requestId = ++recommendationRequestId;

    elements.recommendationsGrid.innerHTML = '';

    for(var index = 0; index < 4; index += 1){
      elements.recommendationsGrid.appendChild(skeleton());
    }

    showShelf(elements.recommendations,true);

    try{
      var response = await fetch(
        rootPath() +
        'recommendations/products.json?product_id=' +
        encodeURIComponent(productId) +
        '&limit=8&intent=related',
        {
          headers:{'Accept':'application/json'}
        }
      );

      if(!response.ok){
        throw new Error('Recommendations could not be loaded.');
      }

      var payload = await response.json();

      if(requestId !== recommendationRequestId){
        return;
      }

      var recentHandles = recentItems
        .map(function(item){return item && item.handle;})
        .filter(Boolean);

      var seen = {};

      var products = (payload.products || [])
        .filter(function(product){
          if(!product || !product.handle) return false;
          if(recentHandles.indexOf(product.handle) !== -1) return false;
          if(seen[product.handle]) return false;

          seen[product.handle] = true;
          return true;
        })
        .slice(0,4);

      elements.recommendationsGrid.innerHTML = '';

      products.forEach(function(product){
        var card = miniCard(product,'recommendation');
        if(card){
          elements.recommendationsGrid.appendChild(card);
        }
      });

      showShelf(
        elements.recommendations,
        elements.recommendationsGrid.children.length > 0
      );
    }catch(error){
      if(requestId !== recommendationRequestId){
        return;
      }

      elements.recommendationsGrid.innerHTML = '';
      showShelf(elements.recommendations,false);
    }
  }

  function renderDiscoveryShelves(){
    var elements = shelfElements();
    if(!elements) return;

    var items = readRecent();
    renderRecent(elements,items);

    var latest = items[0];

    loadRecommendations(
      elements,
      latest && latest.id,
      items
    );
  }

  document.addEventListener('click',function(event){
    var wishlist = event.target.closest('[data-z2-wishlist]');
    if(wishlist) return;

    var card = event.target.closest('.z2-bs-card');

    if(card){
      rememberCard(card);
      return;
    }

    var mini = event.target.closest('[data-z2-bs-mini-product]');

    if(mini){
      rememberProduct({
        id:mini.dataset.productId || '',
        handle:mini.dataset.productHandle || '',
        title:mini.dataset.productTitle || '',
        url:mini.dataset.productUrl || mini.href || '',
        image:mini.dataset.productImage || '',
        priceCents:Number(mini.dataset.productPriceCents || 0)
      });
    }
  },true);

  window.addEventListener('storage',function(event){
    if(event.key === RECENT_KEY){
      renderDiscoveryShelves();
    }
  });

  document.addEventListener(
    'DOMContentLoaded',
    renderDiscoveryShelves
  );

  document.addEventListener(
    'shopify:section:load',
    renderDiscoveryShelves
  );

  if(document.readyState !== 'loading'){
    renderDiscoveryShelves();
  }

  setTimeout(renderDiscoveryShelves,400);
})();


(function () {
  'use strict';

  var PRODUCT_CACHE = new Map();
  var WISHLIST_KEY = 'z2_wishlist_items';
  var RECENT_KEY = 'z2tnfix_recent_products';

  function init(root) {
    if (!root || root.dataset.exactTrendingQvReady === 'true') return;
    root.dataset.exactTrendingQvReady = 'true';

    var $ = function (selector, scope) {
      return (scope || root).querySelector(selector);
    };

    var $$ = function (selector, scope) {
      return Array.from((scope || root).querySelectorAll(selector));
    };

    var shopRoot = (
      root.dataset.routeRoot ||
      (window.Shopify && Shopify.routes && Shopify.routes.root) ||
      '/'
    ).replace(/\/?$/, '/');

    var currency = (
      root.dataset.currency ||
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      'USD'
    );

    var drawer = $('.z2tnfix-drawer', root);
    var qvBody = $('[data-qv-body]', root);
    var live = $('[data-live]', root);
    var toast = $('[data-toast]', root);

    var currentProduct = null;
    var lastQvCard = null;
    var lastFocus = null;
    var previousBodyOverflow = '';
    var toastTimer = null;

    if (!drawer || !qvBody) return;

    function money(cents) {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return '$' + ((Number(cents) || 0) / 100).toFixed(2);
      }
    }

    function esc(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function imageUrl(src, width) {
      if (!src) return '';
      var separator = String(src).indexOf('?') > -1 ? '&' : '?';
      return String(src) + separator + 'width=' + width;
    }

    function clean(html) {
      var documentFragment = new DOMParser().parseFromString(
        html || '',
        'text/html'
      );

      $$(
        'script,style,iframe,object,embed',
        documentFragment
      ).forEach(function (node) {
        node.remove();
      });

      return documentFragment.body.innerHTML;
    }

    function swatchStyle(value) {
      var map = {
        'navy': '#13294b',
        'navy blue': '#13294b',
        'light blue': '#87ceeb',
        'dark blue': '#0b1f3a',
        'rose red': '#c92a5b',
        'wine red': '#722f37',
        'burgundy': '#722f37',
        'beige': '#d8c3a5',
        'khaki': '#c3b091',
        'black': '#111',
        'white': '#fff',
        'gray': '#888',
        'grey': '#888',
        'red': '#d11a2a',
        'blue': '#2463eb',
        'green': '#2f855a',
        'yellow': '#f6d84a',
        'orange': '#f97316',
        'pink': '#ec4899',
        'purple': '#7c3aed',
        'brown': '#7c4a2d',
        'silver': '#c0c0c0',
        'gold': '#d4af37'
      };

      var key = String(value || '').toLowerCase().trim();

      if (
        key === 'multi' ||
        key === 'multicolor' ||
        key === 'multi-color'
      ) {
        return 'linear-gradient(135deg,#ff5f6d,#ffc371,#47cacc,#845ec2)';
      }

      return map[key] || key;
    }

    function addBusinessDays(date, days) {
      var result = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      );

      var remaining = Math.max(0, Number(days) || 0);

      while (remaining > 0) {
        result.setDate(result.getDate() + 1);
        var weekday = result.getDay();
        if (weekday !== 0 && weekday !== 6) remaining -= 1;
      }

      return result;
    }

    function deliveryEstimate(source) {
      source = source || {};

      var minDays = Math.max(
        1,
        Number(source.dataset && source.dataset.deliveryMin) ||
        Number(root.dataset.deliveryMin) ||
        7
      );

      var maxDays = Math.max(
        minDays,
        Number(source.dataset && source.dataset.deliveryMax) ||
        Number(root.dataset.deliveryMax) ||
        14
      );

      var start = addBusinessDays(new Date(), minDays);
      var end = addBusinessDays(new Date(), maxDays);
      var options = { month: 'short', day: 'numeric' };

      return (
        start.toLocaleDateString(undefined, options) +
        '–' +
        end.toLocaleDateString(undefined, options)
      );
    }

    function announce(message) {
      if (!live) return;

      live.textContent = '';

      setTimeout(function () {
        live.textContent = message;
      }, 20);
    }

    function showToast(message) {
      if (!toast) return;

      clearTimeout(toastTimer);
      toast.textContent = message;
      toast.classList.add('on');

      toastTimer = setTimeout(function () {
        toast.classList.remove('on');
      }, 4200);
    }

    function lockBody() {
      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }

    function unlockBody() {
      document.body.style.overflow = previousBodyOverflow;
      previousBodyOverflow = '';
    }

    function recent() {
      try {
        var items = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
        return Array.isArray(items) ? items : [];
      } catch (error) {
        return [];
      }
    }

    function remember(product) {
      var items = recent();

      var item = {
        id: String(product.id || ''),
        handle: product.handle,
        title: product.title,
        url: product.url || shopRoot + 'products/' + product.handle,
        image: product.featured_image || '',
        price: Number(product.price || 0),
        priceCents: Number(product.price || 0)
      };

      items = items.filter(function (existing) {
        return existing && existing.handle !== item.handle;
      });

      items.unshift(item);

      try {
        localStorage.setItem(
          RECENT_KEY,
          JSON.stringify(items.slice(0, 8))
        );
      } catch (error) {}

      document.dispatchEvent(
        new CustomEvent('z2:recent-products-updated', {
          detail: items.slice(0, 8)
        })
      );
    }

    function wishList() {
      try {
        var items = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
        return Array.isArray(items) ? items : [];
      } catch (error) {
        return [];
      }
    }

    function syncQvWish() {
      var button = $('[data-dwish]', qvBody);
      if (!button || !currentProduct) return;

      var active = wishList().some(function (item) {
        return String(item.handle || '') ===
          String(currentProduct.handle || '');
      });

      button.classList.toggle('on', active);
      button.textContent = active
        ? '♥ Saved to Wishlist'
        : '♡ Save to Wishlist';
    }

    function toggleQvWish() {
      if (!currentProduct) return;

      var items = wishList();
      var handle = String(currentProduct.handle || '');

      var index = items.findIndex(function (item) {
        return String(item.handle || '') === handle;
      });

      if (index > -1) {
        items.splice(index, 1);
      } else {
        items.unshift({
          handle: handle,
          title: currentProduct.title || 'Product',
          url: currentProduct.url ||
            shopRoot + 'products/' + handle,
          image: currentProduct.featured_image || '',
          price: money(currentProduct.price || 0)
        });
      }

      items = items.slice(0, 50);

      try {
        localStorage.setItem(
          WISHLIST_KEY,
          JSON.stringify(items)
        );
      } catch (error) {}

      document.dispatchEvent(
        new CustomEvent('z2:wishlist-updated', {
          detail: {
            count: items.length,
            items: items
          }
        })
      );

      syncQvWish();
    }

    function fetchProduct(handle) {
      if (PRODUCT_CACHE.has(handle)) {
        return PRODUCT_CACHE.get(handle);
      }

      var request = fetch(
        shopRoot +
        'products/' +
        encodeURIComponent(handle) +
        '.js',
        {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        }
      ).then(function (response) {
        if (!response.ok) throw response;
        return response.json();
      });

      PRODUCT_CACHE.set(handle, request);

      request.catch(function () {
        PRODUCT_CACHE.delete(handle);
      });

      return request;
    }

    function selectedOptions() {
      return $$('[data-opt-group]', qvBody).map(function (group) {
        var selected = $('.is-selected[data-opt-value]', group);
        return selected ? selected.dataset.optValue : '';
      });
    }

    function variantFor(product) {
      var options = selectedOptions();

      return (product.variants || []).find(function (variant) {
        return (variant.options || []).every(function (option, index) {
          return option === options[index];
        });
      });
    }

    function setMainQvImage(src) {
      var image = $('[data-dimg]', qvBody);
      if (!image || !src) return;

      image.src = imageUrl(src, 900);

      $$('[data-gallery-thumb]', qvBody).forEach(function (button) {
        button.classList.toggle(
          'on',
          button.dataset.gallerySrc === src
        );
      });
    }

    function syncOptionAvailability() {
      if (!currentProduct) return;

      var groups = $$('[data-opt-group]', qvBody);
      var selected = selectedOptions();

      groups.forEach(function (group, groupIndex) {
        $$('[data-opt-value]', group).forEach(function (button) {
          var candidate = selected.slice();
          candidate[groupIndex] = button.dataset.optValue;

          var exists = currentProduct.variants.some(function (variant) {
            return (
              variant.available &&
              (variant.options || []).every(function (option, index) {
                return option === candidate[index];
              })
            );
          });

          button.disabled = !exists;
        });
      });
    }

    function updateVariant() {
      if (!currentProduct) return;

      var variant =
        variantFor(currentProduct) ||
        currentProduct.variants[0];

      var price = $('[data-dprice]', qvBody);
      var compare = $('[data-ddel]', qvBody);
      var add = $('[data-add]', qvBody);
      var buy = $('[data-buy]', qvBody);
      var stock = $('[data-stock]', qvBody);

      if (!variant) return;

      price.textContent = money(variant.price);

      if (
        variant.compare_at_price &&
        variant.compare_at_price > variant.price
      ) {
        compare.textContent = money(variant.compare_at_price);
        compare.hidden = false;
      } else {
        compare.hidden = true;
      }

      add.dataset.variant = variant.id;
      buy.dataset.variant = variant.id;
      add.disabled = buy.disabled = !variant.available;
      add.textContent = variant.available
        ? 'Add to Cart'
        : 'Sold Out';

      stock.textContent = variant.available
        ? '● In stock and ready to order'
        : '● Currently sold out';

      stock.classList.toggle('sold', !variant.available);

      if (
        variant.featured_image &&
        variant.featured_image.src
      ) {
        setMainQvImage(variant.featured_image.src);
      }

      $$('[data-opt-group]', qvBody).forEach(function (group) {
        var selectedButton = $('.is-selected[data-opt-value]', group);
        var current = $('[data-opt-current]', group);

        if (selectedButton && current) {
          current.textContent = selectedButton.dataset.optValue;
        }
      });

      syncOptionAvailability();
    }

    function optionMarkup(product) {
      return (product.options || []).map(function (option, index) {
        var name = typeof option === 'string'
          ? option
          : option.name;

        var values = [];

        (product.variants || []).forEach(function (variant) {
          var value = (variant.options || [])[index];

          if (values.indexOf(value) < 0) {
            values.push(value);
          }
        });

        if (
          name === 'Title' &&
          values.length === 1 &&
          values[0] === 'Default Title'
        ) {
          return '';
        }

        var isColor = /colou?r/i.test(name);

        return (
          '<div class="z2tnfix-qv-option" ' +
          'data-opt-group data-opt-index="' +
          index +
          '">' +
            '<strong>' +
              esc(name) +
              ': <span data-opt-current>' +
              esc(values[0]) +
              '</span></strong>' +
            '<div class="z2tnfix-qv-choices">' +
              values.map(function (value, valueIndex) {
                var style = isColor
                  ? ' style="--z2tnfix-qv-swatch:' +
                    esc(swatchStyle(value)) +
                    '"'
                  : '';

                return (
                  '<button type="button" class="z2tnfix-qv-choice' +
                  (isColor ? ' color' : '') +
                  (valueIndex === 0 ? ' is-selected' : '') +
                  '" data-opt-value="' +
                  esc(value) +
                  '" aria-pressed="' +
                  (valueIndex === 0 ? 'true' : 'false') +
                  '"' +
                  style +
                  '>' +
                    (isColor ? '<i></i>' : '') +
                    '<span>' +
                      esc(value) +
                    '</span>' +
                  '</button>'
                );
              }).join('') +
            '</div>' +
          '</div>'
        );
      }).join('');
    }

    function galleryMarkup(product) {
      var images = (product.images || []).slice(0, 6);

      if (!images.length && product.featured_image) {
        images = [product.featured_image];
      }

      var main = images[0] || '';

      return (
        '<div class="z2tnfix-qv-gallery">' +
          '<img class="z2tnfix-dimg" data-dimg src="' +
          esc(imageUrl(main, 900)) +
          '" alt="">' +
          '<div class="z2tnfix-qv-thumbs">' +
            images.map(function (src, index) {
              return (
                '<button type="button" class="' +
                (index === 0 ? 'on' : '') +
                '" data-gallery-thumb data-gallery-src="' +
                esc(src) +
                '" aria-label="View product image ' +
                (index + 1) +
                '">' +
                  '<img src="' +
                  esc(imageUrl(src, 140)) +
                  '" alt="" loading="lazy">' +
                '</button>'
              );
            }).join('') +
          '</div>' +
        '</div>'
      );
    }

    function qvSkeleton() {
      return (
        '<div class="z2tnfix-qv-skeleton" ' +
        'aria-label="Loading product">' +
          '<i></i><i></i><i></i><i></i>' +
        '</div>'
      );
    }

    async function openQuickView(card) {
      lastQvCard = card;

      var alreadyOpen = root.classList.contains('qv-open');

      if (!alreadyOpen) {
        lastFocus = document.activeElement;
      }

      root.classList.add('qv-open');
      drawer.setAttribute('aria-hidden', 'false');

      if (!alreadyOpen) {
        lockBody();
      }

      qvBody.innerHTML = qvSkeleton();
      drawer.focus();

      try {
        var product = await fetchProduct(card.dataset.handle);
        currentProduct = product;
        remember(product);

        qvBody.innerHTML =
          galleryMarkup(product) +
          '<h2 class="z2tnfix-dtitle" ' +
          'id="z2tnfixQvTitle"></h2>' +
          '<div class="z2tnfix-dprice">' +
            '<strong data-dprice></strong>' +
            '<del data-ddel hidden></del>' +
          '</div>' +
          '<p class="z2tnfix-stock" data-stock></p>' +
          '<div class="z2tnfix-ddesc">' +
            clean(product.description) +
          '</div>' +
          '<div class="z2tnfix-options">' +
            optionMarkup(product) +
          '</div>' +
          '<div class="z2tnfix-drow">' +
            '<div class="z2tnfix-qty-wrap">' +
              '<button type="button" data-qty-minus ' +
              'aria-label="Decrease quantity">−</button>' +
              '<input class="z2tnfix-qty" data-qty ' +
              'type="number" min="1" value="1" ' +
              'aria-label="Quantity">' +
              '<button type="button" data-qty-plus ' +
              'aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button class="z2tnfix-add" ' +
            'data-add type="button">Add to Cart</button>' +
          '</div>' +
          '<button class="z2tnfix-buy" ' +
          'data-buy type="button">Buy It Now</button>' +
          '<div class="z2tnfix-qv-trust">' +
            '<p><b>Estimated delivery:</b> ' +
              esc(deliveryEstimate(card)) +
            '</p>' +
            '<p>✓ Tracked shipping</p>' +
            '<p>✓ ' +
              esc(
                root.dataset.returnText ||
                'Easy returns available'
              ) +
            '</p>' +
          '</div>' +
          '<a class="z2tnfix-view" href="' +
            esc(product.url) +
          '">View full product details</a>' +
          '<button class="z2tnfix-dwish" ' +
          'data-dwish type="button">' +
            '♡ Save to Wishlist' +
          '</button>';

        $('#z2tnfixQvTitle', qvBody).textContent =
          product.title;

        updateVariant();
        syncQvWish();
      } catch (error) {
        qvBody.innerHTML =
          '<div class="z2tnfix-qv-error">' +
            '<strong>Couldn’t load this product.</strong>' +
            '<p>Check your connection and try again.</p>' +
            '<button type="button" data-qv-retry>' +
              'Try Again' +
            '</button>' +
            '<a href="' +
              esc(card.dataset.url) +
            '">Open product page</a>' +
          '</div>';
      }
    }

    function closeQuickView() {
      var wasOpen = root.classList.contains('qv-open');

      root.classList.remove('qv-open');
      drawer.setAttribute('aria-hidden', 'true');
      currentProduct = null;

      if (wasOpen) {
        unlockBody();
      }

      if (lastFocus) {
        lastFocus.focus();
      }
    }

    async function cartRequest(id, quantity) {
      var response = await fetch(
        shopRoot + 'cart/add.js',
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: Number(id),
              quantity: quantity
            }]
          })
        }
      );

      if (!response.ok) {
        var error = await response.json();

        throw Error(
          error.description ||
          error.message ||
          'Unable to add product'
        );
      }

      await response.json();

      var cartResponse = await fetch(
        shopRoot + 'cart.js',
        {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        }
      );

      return cartResponse.json();
    }

    function updateCartUi(cart) {
      document.querySelectorAll(
        '[data-cart-count],.cart-count-bubble span:first-child'
      ).forEach(function (element) {
        element.textContent = cart.item_count;
      });

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: cart
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          detail: cart
        })
      );

      var threshold = Number(root.dataset.freeShipping) || 0;

      if (threshold > 0) {
        var remaining = Math.max(
          0,
          threshold - Number(cart.total_price || 0)
        );

        showToast(
          remaining > 0
            ? 'Added! You’re ' +
              money(remaining) +
              ' away from free shipping.'
            : 'Added! You unlocked free shipping.'
        );
      } else {
        showToast('Product added to cart.');
      }
    }

    async function addCart(id, quantity, buyNow) {
      var button = buyNow
        ? $('[data-buy]', qvBody)
        : $('[data-add]', qvBody);

      if (!button || !id) return;

      button.disabled = true;

      var originalText = button.textContent;
      button.textContent = 'Adding…';

      try {
        var cart = await cartRequest(id, quantity);

        if (buyNow) {
          location.href = shopRoot + 'checkout';
          return;
        }

        updateCartUi(cart);
        button.textContent = 'Added ✓';
        announce('Product added to cart');

        setTimeout(function () {
          if (!button.isConnected) return;
          button.textContent = originalText;
          button.disabled = false;
        }, 1400);
      } catch (error) {
        button.textContent = 'Try Again';
        announce(
          error.message ||
          'Unable to add product'
        );

        setTimeout(function () {
          if (!button.isConnected) return;
          button.textContent = originalText;
          button.disabled = false;
        }, 1800);
      }
    }

    root.addEventListener('click', function (event) {
      var card = event.target.closest('[data-card]');

      if (event.target.closest('[data-dwish]')) {
        event.preventDefault();
        toggleQvWish();
        return;
      }

      if (event.target.closest('[data-qv-close]')) {
        event.preventDefault();
        closeQuickView();
        return;
      }

      if (
        event.target.closest('[data-qv-retry]') &&
        lastQvCard
      ) {
        event.preventDefault();
        openQuickView(lastQvCard);
        return;
      }

      var galleryThumb =
        event.target.closest('[data-gallery-thumb]');

      if (galleryThumb) {
        event.preventDefault();
        setMainQvImage(galleryThumb.dataset.gallerySrc);
        return;
      }

      var choice =
        event.target.closest('[data-opt-value]');

      if (choice) {
        event.preventDefault();

        var group =
          choice.closest('[data-opt-group]');

        $$('[data-opt-value]', group).forEach(function (button) {
          var selected = button === choice;
          button.classList.toggle(
            'is-selected',
            selected
          );
          button.setAttribute(
            'aria-pressed',
            selected ? 'true' : 'false'
          );
        });

        updateVariant();
        return;
      }

      if (
        event.target.closest('[data-qty-minus]') ||
        event.target.closest('[data-qty-plus]')
      ) {
        event.preventDefault();

        var quantityInput =
          $('[data-qty]', qvBody);

        var change =
          event.target.closest('[data-qty-plus]')
            ? 1
            : -1;

        quantityInput.value = Math.max(
          1,
          Number(quantityInput.value || 1) + change
        );

        return;
      }

      var add = event.target.closest('[data-add]');

      if (add) {
        event.preventDefault();

        addCart(
          add.dataset.variant,
          Math.max(
            1,
            Number($('[data-qty]', qvBody).value) || 1
          ),
          false
        );

        return;
      }

      var buy = event.target.closest('[data-buy]');

      if (buy) {
        event.preventDefault();

        addCart(
          buy.dataset.variant,
          Math.max(
            1,
            Number($('[data-qty]', qvBody).value) || 1
          ),
          true
        );

        return;
      }

      if (
        event.target.closest('[data-qv]') &&
        card
      ) {
        event.preventDefault();
        event.stopPropagation();
        openQuickView(card);
      }
    });

    root.addEventListener('mouseover', function (event) {
      var trigger = event.target.closest('[data-qv]');
      var card = trigger
        ? trigger.closest('[data-card]')
        : null;

      if (card && card.dataset.handle) {
        fetchProduct(card.dataset.handle);
      }
    }, { passive: true });

    root.addEventListener('focusin', function (event) {
      var trigger = event.target.closest('[data-qv]');
      var card = trigger
        ? trigger.closest('[data-card]')
        : null;

      if (card && card.dataset.handle) {
        fetchProduct(card.dataset.handle);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (
        event.key === 'Escape' &&
        root.classList.contains('qv-open')
      ) {
        closeQuickView();
      }
    });
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-z2-best-sellers]')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAll(document);
      }
    );
  } else {
    initAll(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAll(event.target);
    }
  );
})();